import { render, staticRenderFns } from "./CollectionTypePicker.vue?vue&type=template&id=b00a176e&"
import script from "./CollectionTypePicker.vue?vue&type=script&lang=js&"
export * from "./CollectionTypePicker.vue?vue&type=script&lang=js&"
import style0 from "./CollectionTypePicker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports